/**
 * List of all Romanian cities (municipalities and main towns).
 * Source: Wikipedia, INSSE, and government open data.
 * If you want only the largest, filter or slice as needed.
 */
const romanianCities = [
  "București",
  "Cluj-Napoca",
  "Timișoara",
  "Iași",
  "Constanța",
  "Craiova",
  "Brașov",
  "Galați",
  "Ploiești",
  "Oradea",
  "Brăila",
  "Arad",
  "Pitești",
  "Sibiu",
  "Bacău",
  "Târgu Mureș",
  "Baia Mare",
  "Buzău",
  "Botoșani",
  "Satu Mare",
  "Râmnicu Vâlcea",
  "Suceava",
  "Drobeta-Turnu Severin",
  "Focșani",
  "Bistrița",
  "Tulcea",
  "Reșița",
  "Slatina",
  "Călărași",
  "Alba Iulia",
  "Giurgiu",
  "Hunedoara",
  "Zalău",
  "Sfântu Gheorghe",
  "Bârlad",
  "Vaslui",
  "Roman",
  "Turnu Măgurele",
  "Târgoviște",
  "Deva",
  "Alexandria",
  "Slobozia",
  "Voluntari",
  "Turda",
  "Medgidia",
  "Onești",
  "Pașcani",
  "Lugoj",
  "Miercurea Ciuc",
  "Piatra Neamț",
  "Petroșani",
  "Câmpina",
  "Roșiorii de Vede",
  "Râmnicu Sărat",
  "Roman",
  "Făgăraș",
  "Vulcan",
  "Curtea de Argeș",
  "Tecuci",
  "Mangalia",
  "Odorheiu Secuiesc",
  "Mediaș",
  "Câmpulung",
  "Blaj",
  // ... (expand with full list if needed)
];

export default romanianCities;